<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import type { EditorProps } from './ElInputRichText/Editor.vue';
import ElInputContainer from '@/forms/ElInputContainer.vue';
import { TextualValueType, useInput } from './input';
import { InputValidation } from './validation-rules';
export type ElInputRichTextProps = Omit<EditorProps, 'error'> & {
  modelValue?: string;
  errorMessage?: string | boolean;
  label?: string;
  name?: string;
  id?: string;
  hiddenErrorMessage?: boolean;
  setRequiredMark?: boolean;
  validation?: InputValidation;
  hiddenPlugins?: string[];
};

const Editor = defineAsyncComponent(() => import('./ElInputRichText/Editor.vue'));

const props = defineProps<ElInputRichTextProps>();
// @ts-ignore: FIXME Expression produces a union type that is too complex to represent.
const computedValidation = computed<InputValidation[]>(() => [(props.validation ?? '') as InputValidation]);
const computedModelValue = computed(() => props.modelValue);
const emit = defineEmits<{
  (event: 'update:modelValue', value: TextualValueType): void;
}>();
const {
  value,
  errorMessage: validationErrorMessage,
  uuid,
  fieldContext,
} = useInput(computedModelValue, computedValidation, props.name, newValue => {
  emit('update:modelValue', newValue);
});
const defaultId = computed(() => (props.label ? props.label.trim().replaceAll(' ', '') : 'richtext'));
</script>
<template>
  <ElInputContainer
    :name="id || `${uuid}-${defaultId}`"
    :label="props.label"
    :error-message="props.errorMessage || validationErrorMessage"
    :hidden-error-message="props.hiddenErrorMessage"
  >
    <Editor
      :model-value="value"
      :error="!!(errorMessage || validationErrorMessage)"
      :color="color"
      :hidden-plugins="hiddenPlugins ?? []"
      @update:model-value="v => emit('update:modelValue', v)"
      @blur="fieldContext.validate()"
    />
  </ElInputContainer>
</template>
